module.exports = __webpack_public_path__ + "img/Guadeloupe.ad7c752b.svg";